var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showNavigation()
        ? _c(
            "div",
            {
              staticClass: "container-nav px-0 shadow-sm float-left w-100",
              class: {
                "background-light-blue": _vm.isRC1,
                bundleflow: _vm.flowType === "bundle"
              }
            },
            [
              _vm.navData.tab_buttons
                ? _c(
                    "div",
                    {
                      staticClass: "sub-nav sub-nav-rc1 float-left",
                      class: { hide: _vm.isCurrentFlowRC2("RC1") }
                    },
                    _vm._l(_vm.navData.tab_buttons, function(nData, nKey) {
                      return _vm.checkTabDispCond("RC1", nData)
                        ? _c(
                            "button",
                            {
                              key: nKey,
                              staticClass: "nav-item cursorBox",
                              class: {
                                "": nKey != _vm.tab_buttons_last_index,
                                activeTab: nData.status.includes("Active"),
                                disabled: nData.status === "Disabled"
                              },
                              staticStyle: { height: "100%" },
                              attrs: {
                                tabindex: "0",
                                title:
                                  nData.screenReaderDesc + " " + nData.label
                              },
                              on: {
                                keydown: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.redirectTo(nData)
                                },
                                click: function($event) {
                                  return _vm.redirectTo(nData)
                                }
                              }
                            },
                            [
                              nData.status === "InactiveComplete" ||
                              nData.status === "ActiveComplete"
                                ? [_vm._m(0, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.status === "InactiveIncomplete" ||
                              nData.status === "ActiveIncomplete"
                                ? [_vm._m(1, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.name == "NamedInsured" &&
                              (nData.status == "ActiveFirstTime" ||
                                nData.status == "InactiveFirstTime" ||
                                nData.status == "Disabled")
                                ? [_vm._m(2, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.name == "Vehicles" &&
                              (nData.status == "ActiveFirstTime" ||
                                nData.status == "InactiveFirstTime" ||
                                nData.status == "Disabled")
                                ? [_vm._m(3, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.name == "Drivers" &&
                              (nData.status == "ActiveFirstTime" ||
                                nData.status == "InactiveFirstTime" ||
                                nData.status == "Disabled")
                                ? [_vm._m(4, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.name == "PriorInsurance" &&
                              (nData.status == "ActiveFirstTime" ||
                                nData.status == "InactiveFirstTime" ||
                                nData.status == "Disabled")
                                ? [_vm._m(5, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.name == "NewCoverages" &&
                              (nData.status == "ActiveFirstTime" ||
                                nData.status == "InactiveFirstTime" ||
                                nData.status == "Disabled")
                                ? [_vm._m(6, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.name == "CarrierMatches" &&
                              (nData.status == "ActiveFirstTime" ||
                                nData.status == "InactiveFirstTime" ||
                                nData.status == "Disabled")
                                ? [_vm._m(7, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "navi-btn-label" }, [
                                _vm._v(_vm._s(nData.label))
                              ])
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.navData.tab_buttons
                ? _c(
                    "div",
                    {
                      staticClass: "sub-nav sub-nav-rc2 float-left",
                      class: { hide: _vm.isCurrentFlowRC2("RC2") },
                      attrs: { id: "sub-nav-rc2" }
                    },
                    _vm._l(_vm.navData.tab_buttons, function(nData, nKey) {
                      return _vm.checkTabDispCond("RC2", nData)
                        ? _c(
                            "button",
                            {
                              key: nKey,
                              staticClass: "nav-item-rc2 cursorBox",
                              class: {
                                "": nKey != _vm.tab_buttons_last_index,
                                activeTab2: nData.status.includes("Active"),
                                disabled2: nData.status === "Disabled"
                              },
                              staticStyle: { height: "100%" },
                              attrs: {
                                tabindex: "0",
                                title:
                                  nData.screenReaderDesc + " " + nData.label
                              },
                              on: {
                                keydown: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.redirectTo(nData)
                                },
                                click: function($event) {
                                  return _vm.redirectTo(nData)
                                }
                              }
                            },
                            [
                              nData.status === "InactiveComplete" ||
                              nData.status === "ActiveComplete"
                                ? [_vm._m(8, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.status === "InactiveIncomplete" ||
                              nData.status === "ActiveIncomplete"
                                ? [_vm._m(9, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.name == "ContactDetails" &&
                              (nData.status == "ActiveFirstTime" ||
                                nData.status == "InactiveFirstTime" ||
                                nData.status == "Disabled")
                                ? [_vm._m(10, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.name == "DriverVehicleDetails" &&
                              (nData.status == "ActiveFirstTime" ||
                                nData.status == "InactiveFirstTime" ||
                                nData.status == "Disabled")
                                ? [_vm._m(11, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.name == "PolicyDetails" &&
                              (nData.status == "ActiveFirstTime" ||
                                nData.status == "InactiveFirstTime" ||
                                nData.status == "Disabled")
                                ? [_vm._m(12, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.name == "Checkout" &&
                              (nData.status == "ActiveFirstTime" ||
                                nData.status == "InactiveFirstTime" ||
                                nData.status == "Disabled")
                                ? [_vm._m(13, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              nData.name == "Confirmation" &&
                              (nData.status == "ActiveFirstTime" ||
                                nData.status == "InactiveFirstTime" ||
                                nData.status == "Disabled")
                                ? [_vm._m(14, true)]
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "navi-btn-label" }, [
                                _vm._v(_vm._s(nData.label))
                              ])
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e()
            ]
          )
        : _c("div", {
            staticClass:
              "container-nav px-0 shadow-sm float-left w-100 background-light-blue bundleflow blank"
          }),
      _vm._v(" "),
      _vm.flowType === "bundle" ||
      _vm.flowType === "cabundle" ||
      _vm.flowType === "rabundle"
        ? _c("Breadcrumbs", { attrs: { navData: _vm.navData } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", { staticClass: "fas fa-circle fa-stack-2x icon-complete" }),
      _vm._v(" "),
      _c("span", {
        staticClass: "fas fa-check fa-stack-1x",
        staticStyle: { color: "#fff" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", { staticClass: "fas fa-circle fa-stack-2x icon-incomplete" }),
      _vm._v(" "),
      _c("span", {
        staticClass: "fas fa-exclamation fa-stack-1x",
        staticStyle: { color: "#fff" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", {
        staticClass: "fas fa-user fa-stack-2x",
        staticStyle: { visibility: "hidden" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "fas fa-user fa-stack-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", {
        staticClass: "fas fa-car fa-stack-2x",
        staticStyle: { visibility: "hidden" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "fas fa-car fa-stack-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", {
        staticClass: "fas fa-users fa-stack-2x",
        staticStyle: { visibility: "hidden" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "fas fa-users fa-stack-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", {
        staticClass: "fas fa-id-card fa-stack-2x",
        staticStyle: { visibility: "hidden" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "fas fa-id-card fa-stack-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", {
        staticClass: "fas fa-list-alt fa-stack-2x",
        staticStyle: { visibility: "hidden" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "fas fa-list-alt fa-stack-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", {
        staticClass: "fas fa-boxes fa-stack-2x",
        staticStyle: { visibility: "hidden" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "fas fa-boxes fa-stack-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", { staticClass: "fas fa-circle fa-stack-2x icon-complete" }),
      _vm._v(" "),
      _c("span", {
        staticClass: "fas fa-check fa-stack-1x",
        staticStyle: { color: "#fff" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", { staticClass: "fas fa-circle fa-stack-2x icon-incomplete" }),
      _vm._v(" "),
      _c("span", {
        staticClass: "fas fa-exclamation fa-stack-1x",
        staticStyle: { color: "#fff" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", {
        staticClass: "fas fa-folder-plus fa-stack-2x",
        staticStyle: { visibility: "hidden" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "fas fa-folder-plus fa-stack-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", {
        staticClass: "fas fa-folder-plus fa-stack-2x",
        staticStyle: { visibility: "hidden" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "fas fa-folder-plus fa-stack-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", {
        staticClass: "fas fa-folder-plus fa-stack-2x",
        staticStyle: { visibility: "hidden" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "fas fa-folder-plus fa-stack-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", {
        staticClass: "fas fa-shopping-cart fa-stack-2x",
        staticStyle: { visibility: "hidden" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "fas fa-shopping-cart fa-stack-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
      _c("span", {
        staticClass: "fas fa-clipboard-check fa-stack-2x",
        staticStyle: { visibility: "hidden" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "fas fa-clipboard-check fa-stack-2x" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-201dd800", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-201dd800","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/Navigation.vue
// module id = null
// module chunks = 